import React from "react"

import { makeStyles } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"
import { FormattedMessage } from "react-intl"
import Img from "gatsby-image"

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    paddingTop: theme.spacing(16),
    [theme.breakpoints.down("md")]: {
      paddingTop: theme.spacing(8),
    },
  },
  socialText: {
    fontFamily: theme.typography.fontFamily,
    marginBottom: theme.spacing(4),
    fontSize: "28px",
    fontWeight: "bold",
    textAlign: "center",
  },
  flexContainer: {
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    [theme.breakpoints.up("lg")]: {
      maxWidth: theme.spacing(162),
    },
    [theme.breakpoints.between("md", "lg")]: {
      maxWidth: theme.spacing(97),
      justifyContent: "flex-start",
    },
    [theme.breakpoints.between("sm", "md")]: {
      padding: theme.spacing(0, 2),
      justifyContent: "flex-start",
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0, 2),
      flexDirection: "column",
      justifyContent: "center",
      maxWidth: "100%",
    },
  },
  instagramLink: {
    marginTop: theme.spacing(2),
    textAlign: "center",
    [theme.breakpoints.up("lg")]: {
      marginRight: theme.spacing(1),
      "&:last-of-type": {
        marginRight: 0,
      },
    },
    [theme.breakpoints.between("md", "lg")]: {
      "&:nth-child(2), &:nth-child(5)": {
        marginLeft: theme.spacing(8),
        marginRight: theme.spacing(8),
      },
    },
    [theme.breakpoints.between("sm", "md")]: {
      "&:nth-child(2), &:nth-child(5)": {
        marginLeft: theme.spacing(7),
        marginRight: theme.spacing(7),
      },
    },
    [theme.breakpoints.down("sm")]: {
      "&:nth-child(2), &:nth-child(5)": {
        marginLeft: 0,
        marginRight: 0,
      },
    },
  },
  instagramImage: {
    marginLeft: "auto",
    marginRight: "auto",
    width: theme.spacing(26),
    height: theme.spacing(26),
  },
}))

export default props => {
  const classes = useStyles()
  const images = props.feed

  return (
    <div className={classes.root}>
      <Typography variant={"h3"} className={classes.socialText}>
        <FormattedMessage id="followInstagram" />
      </Typography>

      <div className={classes.flexContainer}>
        {images.map(image => (
          <a
            href={`https://www.instagram.com/p/${image.node.shortcode}`}
            className={classes.instagramLink}
            key={image.node.id}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={image.node.display_url}
              alt="Puraearth Instagram Image"
              className={classes.instagramImage}
            />
          </a>
        ))}
      </div>
    </div>
  )
}
